const getErrorMessage = (invalidValues: string[]) => {
  const DISPLAY_VALUE_LIMIT = 15;
  const displayedInvalidValues = invalidValues.slice(0, DISPLAY_VALUE_LIMIT);
  const remainingInvalidValuesCount = invalidValues.length - DISPLAY_VALUE_LIMIT;
  return `\nWe cannot find the following IDs:\n${displayedInvalidValues
    .map((val) => `• ${val}`)
    .join('\n')}${
    remainingInvalidValuesCount > 0 ? `\nand ${remainingInvalidValuesCount} more` : ''
  } \n\nThe IDs above will not be listed on the page.`;
};

export const setErrorMessagesForIds = (
  typedOrPastedValue: string,
  setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>,
  options: string[]
) => {
  const COMMAS_AND_WHITESPACE = /[ ,]+/;
  const newValues = Array.from(
    new Set(
      typedOrPastedValue
        .split(COMMAS_AND_WHITESPACE)
        .map((val) => val.trim())
        .filter((val) => val !== '')
    )
  );

  const invalidValues = newValues.filter((val) => !options.includes(val));
  setErrorMessage(invalidValues.length > 0 ? getErrorMessage(invalidValues) : null);

  return newValues;
};
